/**
 *
 * @param url
 * @param matchString
 */
export const assertCorrectUrlEndpoint = (
	url: string | URL,
	matchString: string
) => {
	if (typeof url === "string") {
		if (!url.includes(matchString))
			throw new Error(`URL must point towards a '${matchString}' endpoint`);
	} else if (!url.pathname.includes(matchString))
		throw new Error(`URL must point towards a '${matchString}' endpoint`);
};
